import { TRowComponentProps } from '@libs/types';
import React, { MouseEventHandler } from 'react';
import { RowEnum } from '../../../types/enums';
import { SelectorRegular } from './SelectorRegular';
import { Selector } from './Selector';

export type TRowComponent = {
    handleClick: MouseEventHandler<HTMLButtonElement>;
} & TRowComponentProps;

const RowComponent: React.FC<TRowComponent> = ({ handleClick, ...props }) => {
    const { value, isSelected, ...rest } = props;

    switch (props.id) {
        case RowEnum.ROW_REGULAR:
            return <SelectorRegular isWidget={false} value={!!isSelected} handleClick={handleClick} {...rest} />;
        case RowEnum.SELECTOR_REGULAR:
            return <Selector handleClick={handleClick} {...props} />;
        default:
            return <SelectorRegular isWidget={false} value={!!isSelected} handleClick={handleClick} {...rest} />;
    }
};

export default RowComponent;
